import React from 'react'

export default function LoadingBox() {
    return (
        <div className="loading_bg">
            <div className="loader">Loading...</div>
        </div>
    )
}
